import type { Consultation } from '@/hooks/patients/usePatientConsultations';

export const getPractitionerName = ({
  doctor,
  nurse
}: {
  doctor?: Consultation['Doctor'];
  nurse?: Consultation['Nurse'];
}) => {
  if (doctor?.DoctorUser) {
    return `${doctor.DoctorUser?.first_name} ${doctor.DoctorUser?.last_name}`;
  }
  if (nurse?.NurseUser) {
    return `${nurse?.NurseUser?.first_name} ${nurse?.NurseUser?.last_name}`;
  }
  return '';
};
